export function isValidLeader(leader) {
  if (!leader) return false
  const { firstname, email } = leader
  return firstname && email
}
